import { get } from 'styled-system';
import { isNotNum } from './isNum';
import px from './px';

/**
 * Returns number formatted as Xpx. Negative
 * numbers will be made absolute.
 */
const getAbsolutePx = (n, scale) => {
  if (isNotNum(n)) {
    return px(get(scale, n, n));
  }

  if (n < 0) {
    return px(Math.abs(n));
  }

  return px(n);
};

export default getAbsolutePx;
